import { validate as isUUID } from 'uuid'
import { useState } from 'react'
import { useLocation, useParams } from 'wouter'
import { ExitIcon } from '@radix-ui/react-icons'
import {
  Dialog,
  DialogContent,
  DialogTrigger,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { useEndSession } from '../hooks/useEndSession'
import { useCreateSessionEvent } from '../hooks/useCreateSessionEvent'
import { useTechnicianPageStore } from '../hooks/useTechnicianPageStore'
import { useTechnicianDocument } from '../hooks/useTechnicianDocument'
import { findSubPageIndex } from '@/pages/TechnicianPage/fns'

export const LeaveSessionButton = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [, setLocation] = useLocation()
  const { projectId, documentId } = useParams<{
    projectId: string
    documentId: string
  }>()

  const currentSessionId = useTechnicianPageStore(
    (state) => state.currentSessionId,
  )
  const currentTechnician = useTechnicianPageStore(
    (state) => state.currentTechnician,
  )

  const { endSession } = useEndSession()
  const { createSessionEvent } = useCreateSessionEvent()
  const { currentPage } = useTechnicianDocument()

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger className="inline-flex items-center space-x-2 justify-center whitespace-nowrap rounded-full text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 bg-secondary text-secondary-foreground shadow-sm hover:opacity-80 h-9 px-6 py-2">
        <ExitIcon className="h-4 w-4" />
        <span>Leave Session</span>
      </DialogTrigger>
      <DialogContent
        ariaLabel="Leave Technician mode"
        className="max-w-lg min-h-0"
      >
        <DialogHeader className="space-y-0">
          <DialogTitle className="text-center mt-2 mb-0">
            Are you sure want to leave the session?
          </DialogTitle>
          <DialogDescription className="flex flex-1"></DialogDescription>
        </DialogHeader>

        <div className="flex justify-center mt-6">
          <Button
            className="flex items-center mx-5 rounded-full"
            variant="secondary"
            onClick={() => {
              setIsOpen(false)
            }}
          >
            Cancel
          </Button>
          <Button
            className="flex items-center mx-5 rounded-full"
            onClick={() => {
              if (
                currentTechnician &&
                currentSessionId &&
                currentPage &&
                currentPage.id
              ) {
                if (isUUID(currentPage.id)) {
                  createSessionEvent({
                    documentPageId: currentPage.id,
                    buttonLabel: 'Leave',
                    completedTimestamp: new Date().toISOString(),
                    subPageIndex: findSubPageIndex(currentPage),
                    onSuccess: () => {
                      endSession()
                    },
                  })
                } else {
                  endSession()
                }
              }
              setLocation(`/p/${projectId}/document/${documentId}/edit`)
            }}
          >
            Leave
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
